var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"column relative " + _vm.columnCSS + ' ' + _vm.blok.layout},_vm._l((_vm.blok.body),function(bk){return _c(bk.component,{key:bk._uid,tag:"component",attrs:{"blok":bk}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }